export default __webpack_public_path__ + "static/media/main_nav_check_orange.f43d4616.svg";